import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import GrowthAnalysisView from './GrowthAnalysisView';

const GrowthAnalysisReport = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Growth Analysis Report" mainTitle="Growth Analysis Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <GrowthAnalysisView />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default GrowthAnalysisReport